import dayjs, { type Dayjs } from 'dayjs'
import duration from 'dayjs/plugin/duration'
import isoWeek from 'dayjs/plugin/isoWeek'
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'
import 'dayjs/locale/de'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/hi'
import 'dayjs/locale/it'
import 'dayjs/locale/ja'
import 'dayjs/locale/ko'
import 'dayjs/locale/pt'
import 'dayjs/locale/ro'
import 'dayjs/locale/ru'
import 'dayjs/locale/ar-sa'
import 'dayjs/locale/uk'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(localizedFormat)
dayjs.extend(isoWeek)

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

export const formatedDate = (date: string | Date, format: string) => {
    return dayjs(date).format('MMM D, h:mm A')
}

export const getShortIsoDate = (date: string | Date | Dayjs) => {
    return dayjs(date).format('YYYY-MM-DD')
}

export const someTimeAgoNotifications = (input: string | Date): string => {
    const time = dayjs(input);
    const now = dayjs();
  
    if (!time.isValid()) return '';
  
    const diffSeconds = now.diff(time, 'second');
    const diffMinutes = now.diff(time, 'minute');
  
    if (diffSeconds < 60) {
      return 'Just now';
    }
  
    if (diffMinutes < 5) {
      return `${diffMinutes} min ago`;
    }
  
    if (time.isToday()) {
      return time.format('h:mm A');
    }
  
    if (time.isYesterday()) {
      return `Yesterday, ${time.format('h:mm A')}`;
    }
  
    if (time.isSame(now, 'year')) {
      return time.format('MMM D, h:mm A');
    }
  
    return time.format('MMM D, YYYY');
  };


  export const someTimeAgo = (input: string | Date): string => {
    const time = dayjs(input);
    const now = dayjs();
  
    if (!time.isValid()) return '';
  
    const diffSeconds = now.diff(time, 'second');
    const diffMinutes = now.diff(time, 'minute');
  
    if (diffSeconds < 60) {
      return 'Just now';
    }
  
    if (diffMinutes < 5) {
      return `${diffMinutes} min ago`;
    }
  
    if (time.isToday()) {
      return time.format('h:mm A');
    }
  
    if (time.isYesterday()) {
      return `Yesterday, ${time.format('h:mm A')}`;
    }
  
    if (time.isSame(now, 'year')) {
      return time.format('MMM D, h:mm A');
    }
  
    return time.format('MMM D, YYYY');
  };

export const someTimeAgoPosts = (input: string | Date): string => {
    const now = dayjs();
    const time = dayjs(input);
    const diffSeconds = now.diff(time, 'second');
    const diffMinutes = now.diff(time, 'minute');
    const diffHours = now.diff(time, 'hour');
  
    if (diffSeconds < 60) return 'Just now';
  
    if (diffMinutes < 60) {
      return `${diffMinutes} min ago`;
    }
  
    if (diffHours < 24 && time.isToday()) {
      return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`;
    }
  
    if (time.isYesterday()) {
      return 'Yesterday';
    }
  
    if (time.isSame(now, 'year')) {
      return time.format('MMM D'); // e.g. "Jun 12"
    }
  
    return time.format('MMM D, YYYY'); // e.g. "Jun 12, 2024"
  };

  export const someTimeAgoMessages = (input: string | Date): string => {
    const now = dayjs();
    const time = dayjs(input);
    const diffSeconds = now.diff(time, 'second');
    const diffMinutes = now.diff(time, 'minute');
    const diffHours = now.diff(time, 'hour');
  
    if (diffSeconds < 60) return 'Just now';
  
    if (diffMinutes < 60) {
      return `${diffMinutes} min ago`;
    }
  
    if (diffHours < 24 && time.isToday()) {
      return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`;
    }
  
    if (time.isYesterday()) {
        return `Yesterday`;
    }
  
    if (time.isSame(now, 'year')) {
      return time.format('MMM D'); // e.g. "Jun 12"
    }
  
    return time.format('MMM D, YYYY'); // e.g. "Jun 12, 2024"
  };


  export const someTimeAgoConversations = (input: string | Date): string => {
    const now = dayjs();
    const time = dayjs(input);
    const diffSeconds = now.diff(time, 'second');
    const diffMinutes = now.diff(time, 'minute');
    const diffHours = now.diff(time, 'hour');
  

    if (diffSeconds < 60) {
      return 'Just now';
    }
  
    if (diffMinutes < 5) {
      return `${diffMinutes} min ago`;
    }
  
    if (time.isToday()) {
      return time.format('h:mm A');
    }
  
  
    if (time.isYesterday()) {
        return `Yesterday`;
    }
  
    if (time.isSame(now, 'year')) {
      return time.format('MMM D'); // e.g. "Jun 12"
    }
  
    return time.format('MMM D, YYYY'); // e.g. "Jun 12, 2024"
  };




export const storyTimeAgo = (time: any) => {
    const timeAgo = someTimeAgoPosts(time)
    return timeAgo.replace('second', 'sec').replace('minute', 'min')
}


export const someTimeAgoFans = (input: string | Date): string => {
  const pad2 = (n: number | string) => String(n).padStart(2, '0')

  // Normalize common DB/UI strings to ISO-ish so dayjs can parse without extra plugins
  const normalize = (v: string | Date) => {
    if (v instanceof Date) return v.toISOString()

    const s = String(v).trim()

    // 1) MySQL style: "YYYY-MM-DD HH:mm[:ss]" -> "YYYY-MM-DDTHH:mm[:ss]"
    if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}(:\d{2})?$/.test(s)) {
      return s.replace(/\s+/, 'T')
    }

    // 2) Locale-ish: "MM/DD/YYYY[, ]HH:mm[:ss][ AM|PM]"
    const m = s.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{4}),?\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM|am|pm)?$/
    )
    if (m) {
      const [, mm, dd, yyyy, hh, mi, ss = '00', ap] = m
      let H = parseInt(hh, 10)
      const ampm = ap ? ap.toLowerCase() : ''
      if (ampm === 'pm' && H < 12) H += 12
      if (ampm === 'am' && H === 12) H = 0
      return `${yyyy}-${pad2(mm)}-${pad2(dd)}T${pad2(H)}:${pad2(mi)}:${pad2(ss)}`
    }

    // 3) Assume already ISO or something dayjs can handle
    return s
  }

  const time = dayjs(normalize(input))
  if (!time.isValid()) return ''

  const now = dayjs()
  const diffSeconds = now.diff(time, 'second')
  const diffMinutes = now.diff(time, 'minute')
  const diffHours   = now.diff(time, 'hour')

  if (diffSeconds < 60) return 'Just now'
  if (diffMinutes < 60) return `${diffMinutes} min ago`
  if (time.isToday())   return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`
  if (time.isYesterday()) return time.format('MMM D')
  if (time.isSame(now, 'year')) return time.format('MMM D')
  return time.format('MMM D, YYYY')
}

export const formatChatTime = (time: any) => {
    if (
        dayjs(dayjs(new Date(`20${time}`)).format('YYYY-MM-DD HH:mm:ss'))
            .fromNow()
            .includes('day')
    ) {
        return dayjs(
            dayjs(new Date(`20${time}`)).format('YYYY-MM-DD HH:mm:ss')
        ).fromNow()
    } else {
        return dayjs(new Date(`20${time}`)).format('LT')
    }
}

export const localeDate = (date: string | Date) => {
    return dayjs(date).format('L')
}

export const wordedDayDate = (date: string | Date) => {
    return dayjs(date).format('dddd, MMMM D, YYYY')
}

export const localeShortWordDate = (date: string | Date) => {
    return dayjs(date).format('ll')
}

export function formatVideoTime(
    value: number,
    mode: 'duration' | 'elapsed' = 'duration'
) {
    if (!Number.isFinite(value) || value <= 0) {
        return '0:00'
    }

    const totalSeconds =
        mode === 'elapsed'
            ? Math.floor(value)
            : Math.ceil(value)

    const hrs = Math.floor(totalSeconds / 3600)
    const mins = Math.floor((totalSeconds % 3600) / 60)
    const secs = totalSeconds % 60

    let ret = ''

    if (hrs > 0) {
        ret += `${hrs}:${mins < 10 ? '0' : ''}`
    }

    ret += `${mins}:${secs < 10 ? '0' : ''}${secs}`

    return ret
}
export const setDateTimeLocale = (loc: string) => {
    switch (loc) {
        case 'chs':
            dayjs.locale('zh-cn')
            break
        case 'cht':
            dayjs.locale('zh-tw')
            break
        case 'de':
            dayjs.locale('de')
            break
        case 'es':
            dayjs.locale('es')
            break
        case 'fr':
            dayjs.locale('fr')
            break
        case 'in':
            dayjs.locale('hi')
            break
        case 'it':
            dayjs.locale('it')
            break
        case 'jp':
            dayjs.locale('ja')
            break
        case 'kr':
            dayjs.locale('ko')
            break
        case 'pt':
            dayjs.locale('pt')
            break
        case 'ro':
            dayjs.locale('ro')
            break
        case 'ru':
            dayjs.locale('ru')
            break
        case 'sa':
            dayjs.locale('ar-sa')
            break
        case 'ua':
            dayjs.locale('uk')
            break
        default:
            dayjs.locale('en')
    }
    dayjs.locale(loc)
}

export const getDateTimeLocale = (loc: string) => {
    switch (loc) {
        case 'chs':
            return 'zh'
        case 'cht':
            return 'zh'
        case 'de':
            return 'de'
        case 'es':
            return 'es'
        case 'fr':
            return 'fr'
        case 'in':
            return 'hi'
        case 'it':
            return 'it'
        case 'jp':
            return 'ja'
        case 'kr':
            return 'ko'
        case 'pt':
            return 'pt'
        case 'ro':
            return 'ro'
        case 'ru':
            return 'ru'
        case 'sa':
            return 'ar'
        case 'ua':
            return 'uk'
        default:
            return 'en'
    }
}
